export enum QuestionTypeEnum {
  Bool = 'bool',
  String = 'string',
  ChoicesMultiple = 'choices_multiple',
  ChoicesMultipleWithComment = 'choices_multi_comm',
  Choices = 'choices',
  Coordinate = 'coordinate',
  Camera = 'camera',
  Image = 'image',
  Camera5 = 'camera5', // 5 photos + comment
  Camera10 = 'camera10', // 10 photos + comment
  Image5 = 'image5', // 5 gallery photos + comment
  Image10 = 'image10', // 10 gallery photos + comment
  Integer = 'integer',
  Speedtest = 'speedtest',
  Port = 'port_info',
  QualityKeeper = 'function', // function + quality_keeper as param in text
}
